import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import DeviationDuperbrowseContext from '../../../../Duperbrowse/DeviationDuperbrowseContext';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import DeviationDumbViewWithIcon from '../../../../DeviationViews/DumboWithIcon';
import DeviationLink from '../../../../Duperbrowse/DeviationLink';
import { getDeviationResourceType, getTranslatedDeviationTitle, } from '../../../../DeviationViews/_helpers';
import ContainerSize from '../../../../ContainerSize';
import SidebarBlockWrapper from '../../../_partials/SidebarBlockWrapper';
import s from './SingleColumnTextual.scss';
var thumbHeight = parseInt(s['sidebar-thumb-height'], 10);
var thumbWidth = parseInt(s['sidebar-thumb-width'], 10);
/** Sidebar block layout id 2 */
var SingleColumnTextual = function (_a) {
    var block = _a.block, parentDeviation = _a.deviation;
    var t = useTranslation().t;
    var isMobile = useContext(MobileContext);
    return (React.createElement(SidebarBlockWrapper, { deviation: parentDeviation, block: block },
        React.createElement(ContainerSize, null, function (_a) {
            var _b, _c;
            var containerWidth = _a.containerWidth;
            return (React.createElement(DeviationDuperbrowseContext, { streamId: "sidebar-textual-".concat(block.contentType), deviations: (_b = block.deviations) !== null && _b !== void 0 ? _b : [], parent: {
                    typeId: getDeviationResourceType(parentDeviation),
                    itemId: parentDeviation.deviationId,
                } }, (_c = block.deviations) === null || _c === void 0 ? void 0 : _c.map(function (deviation, index) { return (React.createElement(BiLoggerContextProvider, { key: index, value: { _rankIndex: index } },
                React.createElement(DeviationLink, { deviation: deviation, key: deviation.deviationId, className: s['thumb'], title: getTranslatedDeviationTitle(deviation, t) },
                    React.createElement(DeviationDumbViewWithIcon, { deviation: deviation, width: isMobile ? containerWidth : thumbWidth, height: thumbHeight, greenLikeCrop: true })))); })));
        })));
};
SingleColumnTextual.displayName = 'SingleColumnTextual';
export default SingleColumnTextual;
//# sourceMappingURL=SingleColumnTextual.js.map